"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComputeRefManager = exports.COMPUTE_REF_MAP_CACHE_KEY = void 0;
const store_1 = require("../exports/store");
const env_1 = require("../utils/env");
const compute_cache_manager_1 = require("./compute_cache_manager");
const compute_reference_manager_1 = require("./compute_reference_manager");
exports.COMPUTE_REF_MAP_CACHE_KEY = 'COMPUTE_REF_MAP_CACHE_KEY';
/**
 * Pass in the current `state`, and return the reference relationship management instance of the computed field in the current state.
 */
const getComputeRefManager = (state) => {
    const refMapCache = compute_cache_manager_1.computeCache.get(exports.COMPUTE_REF_MAP_CACHE_KEY);
    // The server does not have a mechanism to update the refMap, so every time it gets the latest one. cannot be retrieved from the cache.
    if (refMapCache && !(0, env_1.isServer)()) {
        const computeRefManager = new compute_reference_manager_1.ComputeRefManager(refMapCache.refMap, refMapCache.reRefMap);
        return computeRefManager;
    }
    const computeRefManager = new compute_reference_manager_1.ComputeRefManager();
    Object.keys(state.datasheetMap).forEach(datasheetId => {
        const currSnapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        const fieldMap = currSnapshot === null || currSnapshot === void 0 ? void 0 : currSnapshot.meta.fieldMap;
        if (fieldMap) {
            computeRefManager.computeRefMap(fieldMap, datasheetId, state);
        }
    });
    return computeRefManager;
};
exports.getComputeRefManager = getComputeRefManager;
//# sourceMappingURL=helper.js.map